// extracted by mini-css-extract-plugin
export var dropdown = "_si-0";
export var imageWrapper = "_si-3";
export var itemNameContainer = "_si-1";
export var productImage = "_si-2";
export var spinnerWrapper = "_si-4";